import { ref } from 'vue';

import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

const useNavigationStore = defineStore('navigation', () => {
  const documentVisibility = ref(true);

  // Desktop sidebar (Rail state) - expanded by default
  const isNavigationExpanded = useLocalStorage('nav-expanded', true);

  // Mobile sidebar (Visibility state) - hidden by default
  const isMobileMenuOpen = ref(false);

  const setDocumentVisibility = (isVisible: boolean) => {
    documentVisibility.value = isVisible;
  };

  /**
   * Desktop: Toggles the rail mode
   */
  const toggleDesktopMenu = (val: boolean = !isNavigationExpanded.value) => {
    isNavigationExpanded.value = val;
  };

  /**
   * Mobile: Toggles or sets the overlay visibility
   * Used by both the Hamburger button and the Vuetify overlay click
   */
  const toggleMobileMenu = (val: boolean = !isMobileMenuOpen.value) => {
    isMobileMenuOpen.value = val;
  };

  return {
    documentVisibility,
    isNavigationExpanded,
    isMobileMenuOpen,
    setDocumentVisibility,
    toggleDesktopMenu,
    toggleMobileMenu
  };
});

export default useNavigationStore;
